import { render, staticRenderFns } from "./ItemTabAttributes.vue?vue&type=template&id=5ca8805c&scoped=true"
import script from "./ItemTabAttributes.vue?vue&type=script&lang=ts"
export * from "./ItemTabAttributes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8805c",
  null
  
)

export default component.exports